import { apiClient } from '../../../../Shared/React/network/api-client'
import { SagaIterator } from 'redux-saga'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import InvoiceApiRoutes from  "../../../../Shared/React/typings/api-routes/InvoiceApiRoutes"
import actions, { InvoiceActions } from './actions'
import { getType, isActionOf } from 'typesafe-actions'


function* postIgnoreSelectedInvoices(action: InvoiceActions): SagaIterator {
    if (isActionOf(actions.ignoreSelected.request)(action)) {
        var route = action.payload.invoiceGroup === 'Commercial' ? InvoiceApiRoutes.ignoreSelectedCommercialInvoices() : InvoiceApiRoutes.ignoreSelectedInvoices()
        const response = yield call(() => apiClient.post(route, action.payload.invoiceNumbers))
        if (response != null) {
            yield put(actions.ignoreSelected.success(response))
        } else {
            yield put(actions.ignoreSelected.failure(response))
        }
    }
}
function* postHoldSelectedInvoices(action: InvoiceActions): SagaIterator {
    if (isActionOf(actions.holdSelected.request)(action)) {
        var route = InvoiceApiRoutes.holdSelectedInvoices()
        const response = yield call(() => apiClient.post(route, action.payload.invoiceNumbers))
        if (response != null) {
            yield put(actions.holdSelected.success(response))
        } else {
            yield put(actions.holdSelected.failure(response))
        }
    }
}

function* postApproveSelectedInvoices(action: InvoiceActions): SagaIterator {
    if (isActionOf(actions.approveSelected.request)(action)) {
        var route = action.payload.invoiceGroup === 'Commercial' ? InvoiceApiRoutes.approveSelectedCommercialInvoices() : InvoiceApiRoutes.approveSelectedInvoices();
        const response = yield call(() => apiClient.post(route, action.payload.invoiceGroup === 'Commercial' ? action.payload : action.payload.invoiceNumbers))
        if (response != null) {
            yield put(actions.approveSelected.success(response))
        } else {
            yield put(actions.approveSelected.failure(response))
        }
    }
}

function* postApproveAllStandardInvoices(action: InvoiceActions): SagaIterator {
    if (isActionOf(actions.approveStandardInvoices.request)(action)) {
        const response = yield call(() => apiClient.post(InvoiceApiRoutes.approveStandardInvoices(action.payload), {}))
        if (response != null) {
            yield put(actions.approveStandardInvoices.success(response))
        } else {
            yield put(actions.approveStandardInvoices.failure(response))
        }
    }
}

function* postApproveBatch(action: InvoiceActions): SagaIterator {
  if (isActionOf(actions.approveBatch.request)(action)) {
    debugger;
      const response = yield call(() => apiClient.post(
        InvoiceApiRoutes.approveBatch(action.payload.invoiceGroup), 
        { 
          invoiceType: action.payload.invoiceType,
          batchSize: action.payload.batchSize
        }))
      if (response != null) {
          yield put(actions.approveBatch.success(response))
      } else {
          yield put(actions.approveBatch.failure(response))
      }
  }
}

function* postApproveInvoiceWithUpload(action: InvoiceActions): SagaIterator {
    if (isActionOf(actions.approveInvoiceWithUpload.request)(action)) {
        const response = yield call(() => apiClient.post(InvoiceApiRoutes.approveInvoiceWithUpload(), action.payload))
        if (response != null) {
            yield put(actions.approveInvoiceWithUpload.success(response))
        } else {
            yield put(actions.approveInvoiceWithUpload.failure(response))
        }
    }
}

function* getGetInvoicePdfData(action: InvoiceActions): SagaIterator {
    if (isActionOf(actions.getInvoicePdfData.request)(action)) {
        const response = yield call(() => apiClient.get(InvoiceApiRoutes.getInvoicePdfData(action.payload.documentKey, "false")))
        if (response != null) {
            yield put(actions.getInvoicePdfData.success(response))
        } else {
            yield put(actions.getInvoicePdfData.failure(response))
        }
    }
}

function* getPreviewInvoice(action: InvoiceActions): SagaIterator {
    if (isActionOf(actions.previewInvoice.request)(action)) {
        const response = yield call(() => apiClient.get(InvoiceApiRoutes.previewInvoice(action.payload)))
        if (response != null) {
            yield put(actions.previewInvoice.success(response))
        } else {
            yield put(actions.previewInvoice.failure("Error"))
        }
    }
}

function* openInvoiceTab(action: InvoiceActions): SagaIterator {
    if (isActionOf(actions.openInvoiceTab.request)(action)) {
        const response = yield call(() => apiClient.get(InvoiceApiRoutes.openInvoiceTab(action.payload.documentKey)))
        if (response != null) {
            var a = document.createElement('a');
            var invoiceData = response;
            var pdfData = atob(invoiceData);
            const pdfDataArr = new Uint8Array(pdfData.length);
            for (var i = 0; i < pdfData.length; i++) {
                pdfDataArr[i] = pdfData.charCodeAt(i);
            }

            const blobPdf = new Blob([pdfDataArr], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blobPdf);
            a.href = blobUrl;
            a.download = "Invoice";
            document.body.appendChild(a);
            a.click();
            yield put(actions.openInvoiceTab.success(response))
        } else {
            yield put(actions.openInvoiceTab.failure(response))
        }
    }
}

export default function* sagas(): SagaIterator {
    yield all([
        yield takeLatest(getType(actions.ignoreSelected.request), postIgnoreSelectedInvoices),
        yield takeLatest(getType(actions.holdSelected.request), postHoldSelectedInvoices),
        yield takeLatest(getType(actions.previewInvoice.request), getPreviewInvoice),
        yield takeLatest(getType(actions.approveSelected.request), postApproveSelectedInvoices),
        yield takeLatest(getType(actions.approveStandardInvoices.request), postApproveAllStandardInvoices),
        yield takeLatest(getType(actions.approveInvoiceWithUpload.request), postApproveInvoiceWithUpload),
        yield takeLatest(getType(actions.approveBatch.request), postApproveBatch),
        yield takeLatest(getType(actions.getInvoicePdfData.request), getGetInvoicePdfData),
        yield takeLatest(getType(actions.openInvoiceTab.request), openInvoiceTab),
    ]);
}
